import React from 'react';

const Skills = () => {
  return (
    <div id="fh5co-skills" className="animate-box">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>Skills</h2>
          </div>
        </div>
        <div className="row row-pb-md">
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="85"><span><strong>Kotlin</strong>85%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="90"><span><strong>Java</strong>90%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="80"><span><strong>GraphQL</strong>80%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="85"><span><strong>Spring Boot</strong>85%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="85"><span><strong>Microservices</strong>85%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="75"><span><strong>OAuth2</strong>75%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="70"><span><strong>Docker</strong>70%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="65"><span><strong>Kubernetes</strong>65%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="70"><span><strong>CI/CD</strong>70%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="70"><span><strong>React</strong>70%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="60"><span><strong>Angular</strong>60%</span></div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12 text-center">
            <div className="chart" data-percent="75"><span><strong>Oracle DB</strong>75%</span></div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="progress-wrap">
              <h3><span className="name-left">Kotlin</span><span className="value-right">85%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-1 progress-bar-striped active" role="progressbar"
                aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width:'85%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Java (8/11/17)</span><span className="value-right">90%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-2 progress-bar-striped active" role="progressbar"
                aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style={{width:'90%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">GraphQL</span><span className="value-right">80%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-3 progress-bar-striped active" role="progressbar"
                aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{width:'80%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Spring Boot & Microservices</span><span className="value-right">85%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-1 progress-bar-striped active" role="progressbar"
                aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width:'85%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">React</span><span className="value-right">70%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-2 progress-bar-striped active" role="progressbar"
                aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width:'70%'}}>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="progress-wrap">
              <h3><span className="name-left">OAuth2 & Security</span><span className="value-right">75%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-4 progress-bar-striped active" role="progressbar"
                aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{width:'75%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Docker & Kubernetes</span><span className="value-right">70%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-5 progress-bar-striped active" role="progressbar"
                aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width:'70%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">CI/CD (Jenkins, GitLab)</span><span className="value-right">70%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-1 progress-bar-striped active" role="progressbar"
                aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width:'70%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Oracle & MySQL</span><span className="value-right">75%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-2 progress-bar-striped active" role="progressbar"
                aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{width:'75%'}}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Git & Version Control</span><span className="value-right">80%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-3 progress-bar-striped active" role="progressbar"
                aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{width:'80%'}}>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
